export default {
    validate: {
        required: 'The field must be filled in!'
    }
}
